import { useTranslation } from 'react-i18next'
import { useCurrentUser } from 'context/useCurrentUser'
import { paths } from '../paths'
import { DropdownMenuItemIndicatorStyled, DropdownMenuRadioItemStyled, LinkStyled } from '../NavbarMenuStyled'

export const GuardianProfileButton = () => {
  const { currentUser } = useCurrentUser()
  const { t } = useTranslation()

  if (!currentUser?.guardian_account) {
    return <></>
  }

  const changeProfile = () => {
    window.localStorage.removeItem('current_user')
    window.location.href = paths.account.profileChange('guardian')
  }

  return (
    <>
      <DropdownMenuRadioItemStyled value='guardian'>
        <DropdownMenuItemIndicatorStyled />
        <LinkStyled onClick={changeProfile}>{t('guardian')}</LinkStyled>
      </DropdownMenuRadioItemStyled>
    </>
  )
}
